<template>
    <div class="card" v-if="counselor">
        <div v-if="!counselor.image" class="col profile-pic">
            <p>{{ getInitials }}</p>
        </div>
        <div class="col details">
            <router-link :to="{ name: 'profile', params: { counselor_user_id: counselor.user_id }}">
                <div id="name">{{ counselor.name || 'Unknown' }}</div>
            </router-link>
            <div id="university">{{ counselor.college || counselor.university }}</div>
            <div class="online-now" v-if="counselor.is_online">
                &#9679; Online Now
            </div>
            <div id="tags"><!-- Tags go here --></div>
        </div>
        <div class="col reviews">
            <span v-for="index in (Math.round(counselor.avg_rating) || 0)" 
                  class="star" 
                  :key="index">
                &#9733;
            </span>
        </div>
        <div class="col rates">
            <p class="rate">${{ counselor.hourly }}</p>
            <p class="unit-label">Per Hour</p>
        </div>
        <div class="col book-meeting-btn">
            <template v-if="isAuthenticated()">
                <button @click="startChat">
                    <img src="./../assets/images/friend-icon.svg"
                         style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(281deg) brightness(108%) contrast(108%);" />
                </button>
            </template>
            <template v-else>
                <a href="/auth/login">
                    <button>
                        <img src="./../assets/images/friend-icon.svg"
                             style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(281deg) brightness(108%) contrast(108%);" />
                    </button>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import Auth from '../auth/auth.js';
import {useRouter} from 'vue-router';
import auth from "@/auth/auth";
// import io from "socket.io-client";
// import {ref} from "vue";

const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

export default {
    props: {
        counselor: {
            type: Object,
            required: true
        },
    },
    setup(){
      const router = useRouter();
      return {router};
    },
    computed: {
        getInitials() {
            if (!this.counselor.name) return '';
            const names = this.counselor.name.split(" ");
            return names.length >= 2 ? 
                   `${names[0][0] || ''} ${names[1][0] || ''}` : 
                   names[0][0] || '';
        }
    },
    methods: {
        async startChat() {
            const studentId = auth.getUserID();
            const recipientId = this.counselor.user_id;

            if (!studentId || !recipientId) {
                console.error("Missing studentId or recipientId");
                return;
            }

            try {
                // 1. Check if contact already exists
                const check = await fetch(`${API_BASE}/contacts/exists/${studentId}/${recipientId}`);
                const existsData = await check.json();

                // 2. If not exists → create it
                if (!existsData.exists) {
                await fetch(`${API_BASE}/contacts/add`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                    student_user_id: studentId,
                    counselor_user_id: recipientId
                    })
                });
                console.log("Created new contact.");
                }

                // 3. Navigate to messages page
                this.$router.push({
                name: "messages",
                query: {
                    recipient_id: recipientId,
                    name: this.counselor.name
                }
                });

            } catch (err) {
                console.error("Error in startChat:", err);
            }
        },


        isAuthenticated() {
            return Auth.isAuthenticated();
        }
    }

};
</script>



<style>
.card {
    background-color: white;
    border-radius: 12px;
    margin: 8px 0px;
    padding: 1em;
    height: auto;
    display: block;
}

.card .col {
    display: inline-block;
    vertical-align: top;
}

.details {
    margin-left: 1em;
    padding-top: 0.5em;
    width: 45%;
}

.reviews {
    width: 25%;
}


.star {
    font-size: 1em;
    color: #FFD966;
}


.profile-pic {
    background-color: orange;
    width: 3em;
    border-radius: 0.5em;
    font-size: 1.5em;
    height: 3em;
}

.profile-pic p {
    position: relative;
    text-align: center;
    color: white;
    top: 50%;
    transform: translateY(-50%)
}

#name {
    font-size: 1em;
    font-weight: bold;
    margin-bottom: 0.4em;
    display: block;
}

#stars-rating {
    width: 30px;
}

#university {
    font-size: 0.8vw;
    color: gray;
}

.book-meeting-btn {
    display: flex;
    align-items: center;
    /* Align vertically */
    justify-content: flex-start;
    /* Align to the left */
    margin-top: 60px;
    /* Adjust this value as needed */
    margin-right: 30px;
}

.book-meeting-btn button {
    background-color: blue;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 10px 10px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.book-meeting-btn button img {
    color: white;
    width: 20px;

}

.book-meeting-btn button:hover {
    background-color: darkblue;
}

p.unit-label {
    text-align: right;
    font-weight: 200;
    font-size: 0.9em;
    color: gray;
    margin-top: 0.5em;
}

.online-now {
    position: relative;
    display: block;
    font-weight: bold;
    margin-top: 0.5em;
    font-size: 0.8em;
    color: #93cd93;
}
</style>